/*
 * patient (schema)
 */
import { boolean, doublePrecision, integer, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { practitioners } from "../practitioner/practitioner.schema"
import { referrals } from "../referral/referral.schema"
import { users } from "../user/user.schema"

export const patients = schema.table("patients", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	userId: uuid("user_id").references(() => users.id, { onDelete: "set null" }),
	practitionerId: uuid("practitioner_id").references(() => practitioners.id, {
		onDelete: "set null",
	}),
	pcpId: uuid("pcp_id").references(() => referrals.id, { onDelete: "set null" }),

	// --- Client Number (auto-assigned by DB sequence on insert) ---
	clientNumber: integer("client_number"),

	// --- General ---
	firstName: varchar("first_name", { length: 128 }).notNull(),
	lastName: varchar("last_name", { length: 128 }).notNull(),
	dateOfBirth: timestamp("date_of_birth", { withTimezone: true }),
	bloodType: varchar("blood_type", { length: 8 }),
	allergies: varchar("allergies", { length: 512 }),
	kNumber: varchar("k_number", { length: 64 }),
	phone: varchar("phone", { length: 32 }),
	phone2: varchar("phone2", { length: 32 }),
	preferredContact: varchar("preferred_contact", { length: 16 }),
	email: varchar("email", { length: 256 }),
	gender: varchar("gender", { length: 32 }),
	veteran: boolean("veteran").notNull().default(false),
	maritalStatus: varchar("marital_status", { length: 32 }),
	guardian: varchar("guardian", { length: 128 }),
	occupation: varchar("occupation", { length: 128 }),
	employer: varchar("employer", { length: 128 }),
	familyDoctor: varchar("family_doctor", { length: 128 }),
	emergencyContactName: varchar("emergency_contact_name", { length: 128 }),
	emergencyContactRelationship: varchar("emergency_contact_relationship", { length: 64 }),
	emergencyContactPhone: varchar("emergency_contact_phone", { length: 32 }),

	// --- VAC Coverage ---
	vacGramsCovered: doublePrecision("vac_grams_covered"),
	vacStartDate: timestamp("vac_start_date", { withTimezone: true }),
	vacApprovalEndDate: timestamp("vac_approval_end_date", { withTimezone: true }),

	// --- Client Status ---
	clientStatus: varchar("client_status", { length: 64 }),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true })
		.notNull()
		.defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true })
		.notNull()
		.defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, {
		onDelete: "set null",
	}),
	updatedBy: uuid("updated_by").references(() => users.id, {
		onDelete: "set null",
	}),
})
